export const Etiqueta = Object.freeze({
  COMUNICADO: {
    id: "COMUNICADO",
    nombre: "COMUNICADO",
  },
  PUBLICACION: {
    id: "PUBLICACION",
    nombre: "PUBLICACIÓN",
  },
});